import { DeviceData } from "./devices";
import { BasicRequest, HTTPMethod, APIVersion } from "../requests/request";
import { Contest } from "../models/contest";

export class API {

    /**
     * Sign up for an contest
     * @returns {Promise<Contest>} The Promise contains either a device or an APIError if rejected
     */
    public static signUp(contest: string, email: string, full_name: string, zip: string, device: DeviceData, referral?: string): Promise<Contest> {
        let apiRequest = new BasicRequest<Contest>('/contest/' + contest, HTTPMethod.POST, APIVersion.v1_2, undefined, {
            email,
            name: full_name,
            zip,
            device,
            referral
        });
        return apiRequest.send(Contest).then((data): Contest => {
            return <Contest>data.data
        })
    }

}


// WEBPACK FOOTER //
// ./src/api/src/endpoints/contest.ts